var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"86785cc26c094ef1b9b22f144f018835f31deb1e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["os-arg-provincia-salta@sovrahq"]={id:"86785cc26c094ef1b9b22f144f018835f31deb1e"};
      